import request from '@/utils/request'

/**
 * 获取用户列表
 */
export function getUserList(params) {
  return request({
    url: '/client.user_controller/list',
    method: 'get',
    params
  })
}

/**
 * 获取用户详情
 */
export function getUserDetail(userId) {
  return request({
    url: '/client.user_controller/detail',
    method: 'get',
    params: { user_id: userId }
  })
}

/**
 * 禁用用户
 */
export function disableUser(data) {
  return request({
    url: '/client.user_controller/disable',
    method: 'post',
    data
  })
}

/**
 * 启用用户
 */
export function enableUser(data) {
  return request({
    url: '/client.user_controller/enable',
    method: 'post',
    data
  })
}

/**
 * 修改密码
 */
export function resetPassword(data) {
  return request({
    url: '/client.user_controller/resetPassword',
    method: 'post',
    data
  })
}

/**
 * 增加积分
 */
export function addPoints(data) {
  return request({
    url: '/client.user_controller/addPoints',
    method: 'post',
    data
  })
}

/**
 * 充值余额
 */
export function addBalances(data) {
  return request({
    url: '/client.user_controller/addBalances',
    method: 'post',
    data
  })
}

/**
 * 提现余额
 */
export function withdrawalBalances(data) {
  return request({
    url: '/client.user_controller/withdrawalBalances',
    method: 'post',
    data
  })
}

/**
 * 重新绑定邀请人
 */
export function rebindInviter(data) {
  return request({
    url: '/client.user_controller/rebindInviter',
    method: 'post',
    data
  })
}

/**
 * 发送优惠券
 */
export function sendCoupon(data) {
  return request({
    url: '/client.user_controller/sendCoupon',
    method: 'post',
    data
  })
}

/**
 * 配置短信白名单
 */
export function configSmsWhite(data) {
  return request({
    url: '/client.user_controller/configSmsWhite',
    method: 'post',
    data
  })
}

/**
 * 设置用户VIP
 */
export function setVip(data) {
  return request({
    url: '/client.user_controller/setVip',
    method: 'post',
    data
  })
}
